import _ from 'lodash';
import React from 'react';
import { FieldError, InputValidationRules, RegisterOptions } from 'react-hook-form';
import { IntlShape } from 'react-intl';

export function validationErrorToFormError(
  error: FieldError,
  rules: Pick<RegisterOptions, keyof InputValidationRules>,
  intl: IntlShape
): { content: string; pointing: string } | undefined {
  if (!error) return undefined;

  if (error.message) return { content: error.message, pointing: 'above' };

  const rulesToMessages = _.mapValues(rules, (rule) => {
    if (rule instanceof RegExp) {
      return rule.source;
    }
    if (typeof rule === 'object' && 'value' in rule) {
      if (Array.isArray(rule.message)) {
        return rule.message.join(', ');
      }
      return rule.message as string;
    }
    return rule as string | number | boolean;
  });

  return {
    content: intl.formatMessage({ id: `form_error.type.${error.type}` }, rulesToMessages),
    pointing: 'above',
  };
}
